import { AavoForm } from "../../../../common/forms/AavoForm.tsx";
import { FormCommonProps } from "../../../../common/forms/types.ts";
import {
	CustomerOrderLineActionApi,
	CustomerOrderLineActionApi_CustomerOrderLineDirectDeliverDto,
} from "src/api/generated/erp/sales/customerOrder/api/customerOrderLineActionApi.ts";
import { FormNumberField } from "../../../../common/forms/fields/FormNumberField.tsx";
import { CustomerOrderLineView } from "src/api/generated/erp/db/types/tables/customerOrderLineView.ts";
import { requiredNonNegativeFloatRule } from "../../../../common/forms/validation.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface CustomerOrderServiceLineDeliveryFormProps extends FormCommonProps<void> {
	customerOrderLines: CustomerOrderLineView[];
	isRevert: boolean;
}

interface FormValues {
	directDeliverDtos: CustomerOrderLineActionApi_CustomerOrderLineDirectDeliverDto[];
}

export const CustomerOrderNoAcquisitionLineDeliveryForm = ({
	onFormEdited,
	customerOrderLines,
	onCompleted,
	isRevert,
}: CustomerOrderServiceLineDeliveryFormProps) => {
	return (
		<AavoForm
			defaultValues={{
				directDeliverDtos: customerOrderLines.map((customerOrderLine) => ({
					customerOrderLineId: customerOrderLine.customerOrderLineId,
					amount:
						isRevert ?
							customerOrderLine.deliveredQuantity
						:	customerOrderLine.salesQuantityAsWarehouseUnits -
							customerOrderLine.deliveredQuantity,
				})),
			}}
			submit={submitForm}
			columns={1}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.sales.customerOrderLineDirectDelivery.form"),
				data: {
					customerOrderLineIds: customerOrderLines.map((line) => line.customerOrderLineId),
					isRevert,
				},
			}}
			render={({ control }) => (
				<>
					{customerOrderLines.map((customerOrderLine, index) => (
						<FormNumberField
							key={index}
							control={control}
							name={`directDeliverDtos.${index}.amount`}
							label={`${customerOrderLine.lineNumber} | ${customerOrderLine.salesPartNo} | ${customerOrderLine.salesPartDescription}`}
							rules={requiredNonNegativeFloatRule()}
						/>
					))}
				</>
			)}
		/>
	);

	async function submitForm(formValues: FormValues) {
		await CustomerOrderLineActionApi.changeCustomerOrderLineDeliveredQuantity({
			customerOrderLineDtos:
				!isRevert ?
					formValues.directDeliverDtos
				:	formValues.directDeliverDtos.map((dto) => ({
						customerOrderLineId: dto.customerOrderLineId,
						amount: -dto.amount,
					})),
		});
	}
};
